"use strict";
exports.__esModule = true;
exports.ESCAPE_CHARACTER = exports.EOL = exports.COMMENT_DELIMITER = exports.QUOTED_IDENTIFIER_DELIMITER = exports.SEPARATORS = exports.OPERATORS = exports.STRUCTURAL_CHARACTERS = void 0;
var types_1 = require("../types");
exports.STRUCTURAL_CHARACTERS = {
    '(': types_1.StructuralCharacters.OPEN_PARENTHESIS,
    ')': types_1.StructuralCharacters.CLOSE_PARENTHESIS
};
exports.OPERATORS = {
    AND: types_1.Operators.AND,
    OR: types_1.Operators.OR,
    XOR: types_1.Operators.XOR,
    NOT: types_1.Operators.NOT
};
exports.SEPARATORS = new Set([
    0x0020,
    0x0009,
    0x000a,
    0x000d, // Carriage return
].map(function (separator) { return String.fromCodePoint(separator); }));
exports.QUOTED_IDENTIFIER_DELIMITER = String.fromCodePoint(0x0022);
exports.COMMENT_DELIMITER = String.fromCodePoint(0x0023);
exports.EOL = String.fromCodePoint(0x000a);
exports.ESCAPE_CHARACTER = String.fromCodePoint(0x005c);
